import classNames from 'classnames';
import { theme } from 'styles/theme/theme';
import { DivProps } from '../../../../../typings';
import UDText from '../../../../ud-ui/components/text';
import { Header } from '../typography';

interface IProps extends DivProps {
  value: number;
}

function Period(props: IProps) {
  const { value, ...rest } = props;

  return (
    <div {...rest} className={classNames('flex-center flex-col', rest.className)}>
      <Header style={{ lineHeight: '54px' }}>тайм</Header>
      <UDText
        id="value"
        type="subhead"
        style={{
          fontSize: 100,
          lineHeight: '100px',
          color: theme.colors.DarkYellow,
          fontFamily: 'Saira Stencil One',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {value}
      </UDText>
    </div>
  );
}

export default Period;
